module.exports = __webpack_public_path__ + "static/media/bigboxLightblue-Artboard_1.a005c561.png";